module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"image-upload\"> <button class=\"btn btn-default btn-sm btn-block\"> <span>Upload Image</span> <input type=\"file\" class=\"read-image\" accept=\"image/*\"> </button> <div class=\"text-center text-muted small\">")
    ; __append(escapeFn( locals.filename ))
    ; __append("</div> <div class=\"row\"> ")
    ;  if (locals.image) { 
    ; __append(" <figure class=\"col-xs-12\"><img src=\"")
    ; __append(escapeFn( locals.image ))
    ; __append("\" alt=\"Logo\" class=\"img-responsive center-block\"></figure> ")
    ;  } else { 
    ; __append(" <figure class=\"col-xs-6 col-xs-offset-3\"><img src=\"/assets/images/icons/no-image.svg\" alt=\"Logo\" class=\"img-responsive center-block\"></figure> ")
    ;  } 
    ; __append(" </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/image_upload.ejs
// module id = 850
// module chunks = 1